import { render, staticRenderFns } from "./SkuLabelTemplatesTab.vue?vue&type=template&id=57c7ed68&scoped=true"
import script from "./SkuLabelTemplatesTab.vue?vue&type=script&lang=js"
export * from "./SkuLabelTemplatesTab.vue?vue&type=script&lang=js"
import style0 from "./SkuLabelTemplatesTab.vue?vue&type=style&index=0&id=57c7ed68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c7ed68",
  null
  
)

export default component.exports